export function App(_ref) {
  var a = _ref.children,
      b = _ref.location;
  return a;
}